module.exports = {
  footerText: "Copyright Tracker Networks © "+ new Date().getFullYear(),
};
